var _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 172,
    viewBox: "0 0 182 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.849 101.046C175.356 101.046 174.141 102.261 174.141 103.755C174.141 105.248 175.356 106.464 176.849 106.464C178.343 106.464 179.558 105.248 179.558 103.755C179.558 102.261 178.343 101.046 176.849 101.046ZM176.849 108.259C174.365 108.259 172.345 106.238 172.345 103.755C172.345 101.271 174.365 99.2509 176.849 99.2509C179.333 99.2509 181.354 101.271 181.354 103.755C181.354 106.238 179.333 108.259 176.849 108.259Z",
    fill: "#67E2C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.362 157.445L171.603 162.434L175.291 158.193L169.362 157.445ZM171.152 165.49L166.628 155.423L178.593 156.931L171.152 165.49Z",
    fill: "#67E2C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90231 88.1126L5.2561 87.8669L6.26258 81.1161L12.6427 81.7237L9.56665 68.9818L22.3074 76.0998L21.4957 77.553L12.0778 72.2909L14.8088 83.6029L7.67631 82.9227L6.90231 88.1126Z",
    fill: "#67E2C2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_802_2742",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 182,
    height: 172
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 172H181.354V0H0V172Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_802_2742)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3853 153.69H65.3272V105.419H20.3853V153.69Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0454 95.4323C22.9245 95.4323 20.385 97.9713 20.385 101.092V163.565C20.385 166.686 22.9245 169.226 26.0454 169.226H58.0025C61.1235 169.226 63.6624 166.686 63.6624 163.565V101.092C63.6624 97.9713 61.1235 95.4323 58.0025 95.4323H26.0454ZM58.0025 170.89H26.0454C22.0068 170.89 18.7205 167.605 18.7205 163.565V101.092C18.7205 97.0536 22.0068 93.7678 26.0454 93.7678H58.0025C62.0412 93.7678 65.3269 97.0536 65.3269 101.092V163.565C65.3269 167.605 62.0412 170.89 58.0025 170.89Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3504 163.677H40.3613C39.4408 163.677 38.6946 162.931 38.6946 162.01V160.906C38.6946 159.985 39.4408 159.239 40.3613 159.239H45.3504C46.2709 159.239 47.0172 159.985 47.0172 160.906V162.01C47.0172 162.931 46.2709 163.677 45.3504 163.677Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2881 37.729H96.9526V32.7355H95.2881V37.729Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7405 46.2591L71.386 42.5378L72.6227 41.4237L75.9773 45.145L74.7405 46.2591Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2209 65.7848L59.875 64.7533L60.1901 63.1188L65.536 64.1508L65.2209 65.7848Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.3837 89.1736L64.5642 87.7249L68.8742 85.2881L69.6937 86.7368L65.3837 89.1736Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.856 87.6255L123.323 84.9972L124.158 83.5569L128.691 86.1852L127.856 87.6255Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.495 64.0503L126.192 62.4141L131.863 61.3616L132.166 62.9983L126.495 64.0503Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.533 45.2606L115.23 44.2247L118.335 40.3175L119.638 41.3534L116.533 45.2606Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.9653 97.6516H103.056V95.9871H86.9653V97.6516Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5921 66.6176C89.7854 66.6176 89.0231 66.9294 88.4466 67.5064C87.7519 68.2005 87.4423 69.1632 87.5971 70.148C87.8241 71.5939 89.1668 72.6842 90.7203 72.6842H93.6238V69.7802C93.6238 68.2266 92.5341 66.8839 91.0882 66.6564C90.9217 66.6303 90.7558 66.6176 90.5921 66.6176ZM95.2883 74.3487H90.7203C88.355 74.3487 86.3055 72.6537 85.9526 70.406C85.7146 68.8902 86.1945 67.4038 87.2692 66.3285C88.3439 65.2549 89.8292 64.7738 91.3462 65.0124C93.5938 65.3659 95.2883 67.4149 95.2883 69.7802V74.3487Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7268 72.6839H102.63C104.184 72.6839 105.527 71.5936 105.753 70.1483C105.909 69.1635 105.599 68.2008 104.905 67.5067C104.211 66.812 103.248 66.5024 102.262 66.6567C100.817 66.8836 99.7268 68.2263 99.7268 69.7804V72.6839ZM102.63 74.3484H98.0623V69.7804C98.0623 67.4146 99.7573 65.365 102.004 65.0127C103.522 64.7741 105.008 65.2546 106.082 66.3299C107.157 67.4041 107.636 68.8899 107.398 70.4063C107.045 72.6534 104.996 74.3484 102.63 74.3484Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.0623 87.6646H99.7268V73.2388H98.0623V87.6646Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.6235 87.6645H95.2881V72.6838H93.6235V87.6645Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.428 103.755H91.368C88.3291 103.755 85.8562 101.283 85.8562 98.2431V89.3291H87.5207V98.2431C87.5207 100.365 89.2468 102.09 91.368 102.09H101.428C103.549 102.09 105.276 100.365 105.276 98.2431V89.3291H106.94V98.2431C106.94 101.283 104.468 103.755 101.428 103.755Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9329 108.194H95.2558C92.4234 108.194 90.1191 105.889 90.1191 103.057H91.7837C91.7837 104.971 93.3411 106.529 95.2558 106.529H97.9329C99.8477 106.529 101.406 104.971 101.406 103.057H103.07C103.07 105.889 100.765 108.194 97.9329 108.194Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6752 49.9355C85.509 49.9355 76.4235 59.0204 76.4235 70.1871C76.4235 81.3538 85.509 90.4387 96.6752 90.4387C107.842 90.4387 116.927 81.3538 116.927 70.1871C116.927 59.0204 107.842 49.9355 96.6752 49.9355ZM96.6752 92.1033C84.5908 92.1033 74.759 82.2715 74.759 70.1871C74.759 58.1027 84.5908 48.271 96.6752 48.271C108.76 48.271 118.591 58.1027 118.591 70.1871C118.591 82.2715 108.76 92.1033 96.6752 92.1033Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.2949 149.212C90.2949 152.941 92.4133 156.005 95.0111 156.005C97.6088 156.005 99.7272 152.941 99.7272 149.212V142.039H90.2949V149.212Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.688 172H69.2107V170.335H128.024V163.677H70.8752V162.013H129.688V172Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7334 156.3C91.6741 156.3 89.1851 153.048 89.1851 149.05V142.594H90.8496V149.05C90.8496 152.078 92.6284 154.636 94.7334 154.636C96.8391 154.636 98.6173 152.078 98.6173 149.05V142.594H100.282V149.05C100.282 153.048 97.7934 156.3 94.7334 156.3Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.717 163.294L73.3333 162.368C75.5138 159.108 76.9785 154.263 76.9785 150.311V142.039H78.6431V150.311C78.6431 154.631 77.1017 159.727 74.717 163.294Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.338 163.042C113.964 159.491 112.489 154.613 112.489 150.311V142.039H114.153V150.311C114.153 154.302 115.52 158.824 117.722 162.116L116.338 163.042Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7077 88.7742H27.0432V49.6703C27.0432 47.9813 28.4974 46.6064 30.2851 46.6064H63.1077V48.271H30.2851C29.4151 48.271 28.7077 48.899 28.7077 49.6703V88.7742Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.988 143.148H71.4304V141.484H159.988C161.025 141.484 161.869 140.73 161.869 139.803V49.6725C161.869 48.9001 161.16 48.271 160.289 48.271H134.682V46.6064H160.289C162.078 46.6064 163.534 47.9819 163.534 49.6725V139.803C163.534 141.648 161.942 143.148 159.988 143.148Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5852 88.7743H35.9207V56.5936L58.669 56.5975V58.262L37.5852 58.2581V88.7743Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.211 130.942H71.9849V129.278H153.546V58.1849L138.57 58.2582L138.562 56.5936L155.211 56.5121V130.942Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.804 136.168C155.804 137.333 154.861 138.277 153.696 138.277C152.531 138.277 151.587 137.333 151.587 136.168C151.587 135.004 152.531 134.059 153.696 134.059C154.861 134.059 155.804 135.004 155.804 136.168Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.37 136.168C147.37 137.333 146.426 138.277 145.261 138.277C144.097 138.277 143.153 137.333 143.153 136.168C143.153 135.004 144.097 134.059 145.261 134.059C146.426 134.059 147.37 135.004 147.37 136.168Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.935 136.168C138.935 137.333 137.991 138.277 136.826 138.277C135.662 138.277 134.718 137.333 134.718 136.168C134.718 135.004 135.662 134.059 136.826 134.059C137.991 134.059 138.935 135.004 138.935 136.168Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.443 172H150.772V170.335H147.443V172Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4236 172H143.004V170.335H76.4236V172Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1531 126.503H37.5853V117.071H28.1531V126.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.353 117.626H54.7853V115.961H45.353V117.626Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.353 125.948H54.7853V124.284H45.353V125.948Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1531 134.271H54.7853V132.606H28.1531V134.271Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1531 143.148H54.7853V141.484H28.1531V143.148Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1531 43.2774H29.8176V8.87744H28.1531V43.2774Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8194 56.67C7.96471 52.719 0 41.6627 0 29.1583C0 13.1718 13.0065 0.165222 28.9931 0.165222C37.6491 0.165222 45.7864 3.99028 51.3181 10.6589L50.0376 11.722C44.8226 5.43508 37.152 1.82974 28.9931 1.82974C13.9242 1.82974 1.66452 14.0895 1.66452 29.1583C1.66452 40.9448 9.17204 51.3663 20.3454 55.0909L19.8194 56.67Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3477 54.2518C17.8456 50.2891 13.5855 42.9325 13.1822 30.3832C12.5347 10.3679 24.9581 1.0988 25.4874 0.714294L26.4672 2.05978C26.3446 2.14911 14.228 11.2324 14.8456 30.3299C15.2334 42.3832 19.2737 49.392 22.595 53.1499L21.3477 54.2518Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8766 43.6763L41.2953 43.1564C42.5409 39.3719 43.2472 35.0963 43.3964 30.4479C44.0151 11.2699 31.8963 2.1483 31.7737 2.05842L32.7557 0.7146C33.2851 1.10132 45.7085 10.4076 45.0598 30.5017C44.9062 35.3088 44.1716 39.7414 42.8766 43.6763Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1853 39.9483H43.1337V38.2838H3.1853V39.9483Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.63037 20.529H43.1336V18.8645H2.63037V20.529Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.288 57.7033H168.527V56.0388H179.624V1.66458H104.165V28.2968H102.501V6.10352e-05H181.288V57.7033Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.411 34.9548H174.075V32.7355H172.411V34.9548ZM172.411 39.3935H174.075V37.1742H172.411V39.3935ZM172.411 43.8322H174.075V41.6129H172.411V43.8322ZM172.411 48.271H174.075V46.0516H172.411V48.271Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.075 32.7356H172.411V8.32266H109.714V6.65814H174.075V32.7356Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.979 33.7379L120.867 28.4137V27.2885L132.002 21.5698V23.403L123.013 27.7989L131.979 31.9047V33.7379Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.552 37.9599H133.881L141.722 18.4268H143.416L135.552 37.9599Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.678 31.8236L154.656 27.7988L145.701 23.3218V21.512L156.813 27.3V28.4253L145.678 33.6679V31.8236Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.022 121.412L127.143 119.613L122.57 105.977L132.092 95.1978L146.188 98.0552L150.761 111.691L145.455 117.698L144.208 116.596L148.878 111.31L144.915 99.4955L132.704 97.0204L124.453 106.358L128.416 118.173L136.353 119.782L136.022 121.412Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.627 105.419C136.241 105.419 135.854 105.481 135.477 105.608C133.593 106.24 132.573 108.288 133.206 110.172C133.512 111.085 134.156 111.825 135.018 112.253C135.879 112.682 136.858 112.751 137.771 112.444C139.655 111.811 140.674 109.764 140.042 107.88C139.736 106.966 139.092 106.227 138.231 105.798C137.724 105.546 137.177 105.419 136.627 105.419ZM136.619 114.299C135.815 114.299 135.017 114.112 134.276 113.744C133.016 113.117 132.075 112.036 131.627 110.702C130.704 107.947 132.193 104.954 134.948 104.03C136.282 103.581 137.711 103.681 138.972 104.308C140.232 104.935 141.172 106.015 141.62 107.35C142.544 110.105 141.055 113.098 138.3 114.022C137.749 114.207 137.183 114.299 136.619 114.299Z",
    fill: "#108DA0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3148 22.0381C69.9896 21.941 69.437 21.8106 68.6891 21.8106C65.8289 21.8106 63.5208 24.5088 63.5208 27.6619C63.5208 29.0923 64.236 30.1326 65.6663 30.1326C67.5517 30.1326 69.2744 27.7268 69.6323 25.7117L70.3148 22.0381ZM72.103 35.9057C70.3148 36.8484 68.4943 37.2057 66.316 37.2057C60.9852 37.2057 56.4666 33.3052 56.4666 27.0638C56.4666 20.3669 61.115 14.5811 68.3318 14.5811C73.9884 14.5811 77.7918 18.547 77.7918 23.9756C77.7918 28.8515 75.0609 31.7123 72.0054 31.7123C70.7048 31.7123 69.5019 30.8345 69.5996 28.8515H69.4698C68.3318 30.769 66.8365 31.7123 64.8857 31.7123C63.0003 31.7123 61.3752 30.1842 61.3752 27.6164C61.3752 23.5855 64.5611 19.9119 69.0797 19.9119C70.4773 19.9119 71.713 20.2043 72.5574 20.5944L71.4527 26.4785C70.965 28.9492 71.3551 30.0866 72.4276 30.1193C74.0855 30.152 75.9386 27.941 75.9386 24.1703C75.9386 19.457 73.1106 16.0758 68.0716 16.0758C62.7734 16.0758 58.3197 20.2693 58.3197 26.8685C58.3197 32.2971 61.8629 35.6455 66.6739 35.6455C68.5271 35.6455 70.2499 35.2555 71.5826 34.5081L72.103 35.9057Z",
    fill: "#67E2C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.6246 9.07145L65.4792 7.41359C66.0269 7.36532 66.5789 7.33148 67.1299 7.34202C67.3529 7.34202 67.576 7.3459 67.7979 7.35367L67.7385 9.01708C67.531 9.01042 67.3213 9.00765 67.1121 9.00654C66.6183 9.00654 66.1179 9.02817 65.6246 9.07145ZM71.9065 9.68399C71.2301 9.48703 70.5366 9.33112 69.8442 9.22126L70.1066 7.57727C70.8667 7.69823 71.6285 7.86912 72.3714 8.0855L71.9065 9.68399ZM61.4994 9.95697L60.9501 8.38567C61.6747 8.13266 62.426 7.92127 63.1839 7.75759L63.5345 9.38494C62.8438 9.53363 62.1591 9.72616 61.4994 9.95697ZM75.7804 11.3591C75.1728 11.0017 74.5392 10.6788 73.8961 10.4008L74.5564 8.87337C75.2627 9.17798 75.9585 9.53197 76.6259 9.92535L75.7804 11.3591ZM57.7204 11.8329L56.8016 10.4447C57.4452 10.0186 58.121 9.62906 58.8106 9.28617L59.5513 10.777C58.9227 11.0894 58.3068 11.4439 57.7204 11.8329ZM79.1255 13.9357C78.625 13.4408 78.0891 12.9725 77.5326 12.5442L78.5485 11.2253C79.1588 11.6953 79.7464 12.2091 80.2957 12.7523L79.1255 13.9357ZM54.5156 14.5788L53.285 13.4569C53.8054 12.886 54.3658 12.3428 54.9506 11.8418L56.0331 13.1062C55.5005 13.5623 54.99 14.0572 54.5156 14.5788ZM81.7388 17.2492C81.3748 16.6478 80.9698 16.0635 80.5348 15.512L81.842 14.4817C82.3186 15.0859 82.763 15.7273 83.1625 16.3881L81.7388 17.2492ZM52.0771 18.0254L50.6096 17.2398C50.9746 16.5584 51.3852 15.8943 51.8308 15.2657L53.189 16.2267C52.7834 16.8004 52.4095 17.4051 52.0771 18.0254ZM83.4577 21.102C83.2529 20.429 83.0044 19.7632 82.7181 19.1218L84.2378 18.4438C84.5524 19.1473 84.8254 19.8792 85.0501 20.6176L83.4577 21.102ZM50.563 21.9653L48.9467 21.567C49.132 20.8157 49.3667 20.0706 49.6436 19.3509L51.1971 19.9485C50.9447 20.6032 50.7316 21.2823 50.563 21.9653ZM84.1729 25.2611C84.1401 24.5564 84.063 23.849 83.9443 23.1583L85.5849 22.8764C85.7148 23.6349 85.7991 24.4105 85.8357 25.1829L84.1729 25.2611ZM48.4019 26.1683V26.0617C48.4019 25.3288 48.4457 24.582 48.5317 23.8507L50.1851 24.0454C50.1063 24.7124 50.0664 25.3937 50.0664 26.0695V26.1544L48.4019 26.1683ZM85.4834 29.8019L83.8522 29.4718C83.9914 28.7854 84.0891 28.0808 84.1423 27.3767L85.8019 27.5026C85.7436 28.275 85.636 29.0484 85.4834 29.8019ZM48.9944 30.7607C48.8019 30.0144 48.6543 29.2471 48.5555 28.4808L50.2067 28.2689C50.2966 28.9663 50.4309 29.6648 50.6062 30.3445L48.9944 30.7607ZM84.0059 34.1945L82.5072 33.471C82.813 32.838 83.0809 32.1794 83.3051 31.5136L84.8825 32.0445C84.6367 32.7758 84.3415 33.4988 84.0059 34.1945ZM50.7017 35.0679C50.3294 34.3893 49.997 33.6824 49.7135 32.9672L51.2609 32.3541C51.5189 33.0055 51.8219 33.6491 52.1609 34.2667L50.7017 35.0679ZM53.4154 38.8219C52.8888 38.2565 52.3934 37.6529 51.9423 37.0292L53.2916 36.0538C53.7028 36.6225 54.1544 37.1724 54.6344 37.6884L53.4154 38.8219ZM56.9636 41.7992C56.3172 41.3803 55.6891 40.9164 55.0976 40.4204L56.1679 39.1448C56.7067 39.5976 57.2787 40.0204 57.8685 40.4026L56.9636 41.7992Z",
    fill: "#108DA0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.3128f76a62dd9bfc76f4b0da85c87f74.svg";
export { ForwardRef as ReactComponent };